import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-bon-sortie-negoce',
  templateUrl: './brouillon-bon-sortie-negoce.component.html',
  styleUrls: ['./brouillon-bon-sortie-negoce.component.scss']
})
export class BrouillonBonSortieNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
